import { getElementAnimationTimeMs, getElementPauseTimeMs } from './timings';

export default function getScribeLengthMs(scribe) {
  return (
    scribe.elements?.reduce((prevTime, el) => {
      return prevTime + getElementAnimationTimeMs(el, scribe) + getElementPauseTimeMs(el, scribe);
    }, 0) || 0
  );
}
